var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a7c9d7d81ad0fd69917a761828fcda61.svg#b';
                    var viewUrl = 'sprites.a7c9d7d81ad0fd69917a761828fcda61.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };